import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { store } from "../redux/store";
import { clinicTrainingApi } from "../redux/Clinictrainingapi";

const AuthContext = createContext(undefined);

function parseUserFromToken(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return { id: payload.user_id ?? payload.sub ?? payload.id ?? 'default' };
  } catch {
    return { id: 'default' };
  }
}

export function AuthProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setIsAuthenticated(true);
      setUser(parseUserFromToken(token));
    }
    setLoading(false);
  }, []);

  const value = useMemo(() => ({
    loading,
    isAuthenticated,
    user,
    setIsAuthenticated,
    login: (accessToken, refreshToken) => {
      localStorage.setItem("accessToken", accessToken);
      if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
      setIsAuthenticated(true);
      setUser(parseUserFromToken(accessToken));
    },
    logout: () => {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      store.dispatch(clinicTrainingApi.util.resetApiState());
      setIsAuthenticated(false);
      setUser(null);
    },
  }), [loading, isAuthenticated, user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (ctx === undefined) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
}